<template>
	<div>
		<Loading v-if="loading" :showText="true"/>
		<ErrorAlert v-else-if="error" :error="error"/>
		<template v-else>
			<div class="row">
				<div class="col-3">
					<PieChart v-if="pieChart != null" :chart="pieChart" :colorPalette="pieChart.colors"/>
				</div>
				<div class="col">
					<TestRunInfoPanel :testRun="testRun" @cancelTestRun="cancelTestRun()"/>
				</div>
			</div>
			<TestsTable :tests="tests" mode="dashboard" @previewResult="previewResult" @cancelTest="cancelTest" />
		</template>
		<FullTextDialog ref="fullTextDialog" />
		<JsonViewDialog ref="jsonViewDialog" />
	</div>
</template>

<script>
import TestsTable from './TestsTable';
import FullTextDialog from './FullTextDialog';
import JsonViewDialog from './JsonViewDialog';
import PieChart from '../chart/PieChart';
import { RUN_STATUS } from '../../util/test-runner-constants';
import { sortByFullPath } from '../../util/test-runner';
import TestRunInfoPanel from './TestRunInfoPanel';
import { cancelTest, cancelTestRun, stopPolling, fetchTestRun } from '../../util/test-runner';
import Loading from '../shared/Loading';
import ErrorAlert from '../shared/ErrorAlert';

export default {
	name: 'TestRunnerDashboardSummary',
	props: ['runId'],
	components: {
		PieChart,
		TestsTable,
		TestRunInfoPanel,
		FullTextDialog,
		JsonViewDialog,
		Loading,
		ErrorAlert
	},
	created() {
		this.pieChartColorPalette = {
			[RUN_STATUS.OK]: '#35b052',
			[RUN_STATUS.FAIL]: '#f74557',
			[RUN_STATUS.CANCELED]: '#6c757d',
			[RUN_STATUS.PENDING]: '#000000',
			[RUN_STATUS.RUNNING]: '#ff6200',
			[RUN_STATUS.SKIPPED]: '#acacac'
		};
	},
	mounted() {
		if (this.runId) {
			this.fetchTestRun(this.runId);
		}
	},
	data: function() {
		return {
			testRun: {},
			loading: false,
			error: null
		};
	},
	watch: {
		runId: function(newVal) {
			if (newVal) {
				this.fetchTestRun(newVal);
			}
		}
	},
	computed: {
		tests() {
			if (!this.testRun || !this.testRun.servicesTests) {
				return [];
			}
			return this.testRun.servicesTests
				.map(({tests}) => sortByFullPath(tests))
				.reduce((mergedArray, val) => mergedArray.concat(val), []);
		},
		pieChart() {

			const countByStatus = this.tests.reduce((state, test) => {
				state[test.status] = (state[test.status] || 0) + 1;
				return state;
			}, {});

			const labels = Object.values(RUN_STATUS).filter((status) => countByStatus[status] > 0);
			const data = labels.map((label) => countByStatus[label]);
			const colors = labels.map((label) => this.pieChartColorPalette[label]);

			return {
				series: ['ExecutedTests'],
				labels,
				data,
				colors
			};
		}
	},
	methods: {
		fetchTestRun(runId) {
			stopPolling(this);
			fetchTestRun(runId, this);
		},
		getExecutedTests() {
			return this.tests.filter((t) => t.status === RUN_STATUS.OK || t.status === RUN_STATUS.FAIL);
		},
		openFullTextDialog(text) {
			this.$refs.fullTextDialog.show(text);
		},
		openJsonViewDialog(json) {
			this.$refs.jsonViewDialog.show(json);
		},
		previewResult(result) {
			if (typeof result === 'object') {
				this.openJsonViewDialog(result);
			} else {
				this.openFullTextDialog(result);
			}
		},
		cancelTest(id) {
			cancelTest(id, this.runId, this);
		},
		cancelTestRun() {
			cancelTestRun(this.runId, this);
		}
	}
};
</script>

<style scoped>
</style>
